'use client';

import { useState, useEffect, useCallback } from 'react';

import { paths } from '../../routes/paths';
import { useRouter, usePathname, useSearchParams } from '../../routes/hooks';

import { CONFIG } from '../../config-global';

import { SplashScreen } from '../../components/loading-screen';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

export function AuthGuard({ children }) {
  const router = useRouter();

  const pathname = usePathname();

  const searchParams = useSearchParams();

  const { authenticated, loading } = useAuthContext();

  const [isChecking, setIsChecking] = useState(true);

  const createQueryString = useCallback(
    (name, value) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(name, value);

      return params.toString();
    },
    [searchParams]
  );

  useEffect(() => {
    const checkPermissions = async () => {
      if (loading) {
        return;
      }

      if (!authenticated) {
        const { method } = CONFIG.auth;

        const signInPath = {
          jwt: paths.auth.jwt.login
        }[method];

        const href = `${signInPath}?${createQueryString('returnTo', pathname)}`;

        router.replace(href);
        return;
      }

      setIsChecking(false);
    };
    checkPermissions();
  }, [authenticated, loading, pathname, router, createQueryString]);

  if (isChecking) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
